module.exports = __webpack_public_path__ + "static/scrap_mountain_2-413678b0f6c2c98a646c39a6e80db189.png";